
import { getMerchantSettleFlag } from '@/api/account';

export const v160Mixins = {
  data() {
    return {
      is25: false,
    };
  },
  async created() {
    if (localStorage.getItem('25infoflag') === null) {
      const data = JSON.parse(localStorage.getItem('LOGIN_INFO'));
      const params = {
        merchantId: data.merchantId,
      };
      await getMerchantSettleFlag(params).then((res) => {
        console.log(res);
        if (res.data.error_code === 0) {
          localStorage.setItem('25infoflag', res.data.data.unionPayAgentFlag);
          this.is25 = res.data.data.unionPayAgentFlag;
        }
      });
    } else {
      this.is25 = localStorage.getItem('25infoflag');
    }
  },
};
export default v160Mixins;
